import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { locationStorage } from './utils/locationStorage';
import './App.css';

function App() {
  const { isAuthenticated } = useAuthStore();

  // Listener para mensagens do Service Worker (Background Sync)
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', async (event) => {
        if (event.data && event.data.type === 'SYNC_LOCATIONS') {
          console.log('🔄 Sincronizando localizações pendentes...');
          // Sincronização será feita pelos componentes que usam o hook
          // Aqui apenas logamos
        }
      });
    }

    // Inicializar IndexedDB na inicialização do app
    locationStorage.init().catch((err) => {
      console.warn('⚠️ Erro ao inicializar IndexedDB:', err);
    });
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Rota pública */}
          <Route 
            path="/login" 
            element={
              isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
            } 
          />
          
          {/* Rotas protegidas */}
          <Route path="/" element={<ProtectedRoute />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
          </Route>
          
          {/* Rota 404 */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;



